import ClaimsService from "@/api/services/claims";
import { approvalStatusClass } from "@/utils/approval_status_class";
import { toCamelCase } from "@estaly/ui";

const initialState = {
  index: [],
};

export default {
  namespaced: true,
  state: initialState,
  getters: {
    getIndex(state) {
      return state.index;
    },
    invoiceStatusClass: () => approvalStatusClass,
  },
  mutations: {
    setIndex(state, data) {
      state.index = data.claimInvoices;
    },
  },
  actions: {
    async fetchIndex({ commit }, { claimId }) {
      const response = await ClaimsService.fetchClaimInvoices({ claimId });
      if (!response?.success) return response;

      const data = toCamelCase(response.data);
      commit("setIndex", data);
      return data;
    },
  },
};
